import { render, staticRenderFns } from "./CreatePartner.vue?vue&type=template&id=58534ebe&"
import script from "./CreatePartner.vue?vue&type=script&lang=js&"
export * from "./CreatePartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports